import { render } from "./VideoBannerFour.vue?vue&type=template&id=683a6617"
import script from "./VideoBannerFour.vue?vue&type=script&lang=js"
export * from "./VideoBannerFour.vue?vue&type=script&lang=js"

import "./VideoBannerFour.vue?vue&type=style&index=0&id=683a6617&lang=css"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__